import { Box, Typography } from "@mui/material";
import getSpeed from "../utils/getSpeedText";
import { getTime, useTATTimeLogic } from "../utils/getTime";
import { HeatingModeEnum, temperatureASCII } from "../utils/constants";

function Settings({ setting, TATFlag }: { setting: any, TATFlag: boolean }) {
    const { time, temperature, speed, heatingMode } = setting;
    const resultTime = useTATTimeLogic({ setting: setting });
    return (
        <Box sx={{ display: 'flex', backgroundColor: '#fff', alignItems: 'center', py: '15px' }}>
            <Typography variant='caption3Light' textAlign='center' width='86px'>
                {getSpeed(speed)}
            </Typography>
            <Typography variant='caption3Light' textAlign='center' width='66px' >
                {temperature + temperatureASCII}C
            </Typography>
            <Typography variant='caption3Light' textAlign='center' width='76px'>
                {[HeatingModeEnum.TAT, HeatingModeEnum.RICECOOKER].includes(heatingMode) && TATFlag
                    ? `≈ ${getTime(resultTime)}` : `${getTime(time)}`}
            </Typography>
        </Box>
    )
}

export default Settings;